import { useQuery } from '@tanstack/react-query';
import Api from '@/services/api';

import _ from 'lodash';

export type FileStatus =
	| 'CORRUPTED_FILE'
	| 'EXTRACTED_DATA'
	| 'NOT_PROCESSED'
	| 'PROCESSING'
	| 'PROCESSED'
	| 'IN_QUEUE';

export type File = {
	id: string;
	url: string;
	size: number;
	tool: string;
	user_id: string;
	duration: number;
	rulaScore: number;
	sector_id: string;
	blurFace: boolean;
	isActive: boolean;
	updatedAt: string;
	created_at?: string;
	createdAt?: string;
	company_id: string;
	workstation: string;
	original_name: string;
	generated_name: string;
	file_processed: string;
	organization_id: string;
	status: FileStatus | boolean;
	workstation_id: string | null;
	workstations: {
		id: string;
		name: string;
		line: {
			id: string;
			name: string;
			sector: {
				id: string;
				name: string;
			};
		};
	};
	sector: {
		id: string;
		name: string;
	};
	operation?: {
		id: string;
		name: string;
	};
};

type FileDTO = Pick<File, 'organization_id' | 'company_id'> & { offset: number; limit: number; filter?: FilterDTO };

export type FileResponse = {
	pages: number;
	count: number;
	rows: File[];
	total: number;
};

export type FilterDTO = {
	created_at?: Date[];
	created_at_end?: string | Date;
	created_at_start?: string | Date;
	offset?: number;
	line_id?: string;
	sector_id?: string;
	company_id?: string;
	file_ids?: React.Key[];
	original_name?: string;
	organization_id?: string;
};

const getCustomReportReviewFiles = async ({
	organization_id,
	company_id,
	filter,
	limit,
	offset
}: FileDTO): Promise<FileResponse> => {
	const params = { limit, offset, organization_id, company_id };
	if (filter) {
		_.assign(params, filter);
	}

	const url = `/custom-report/review/files`;
	const { data } = await Api.get<FileResponse>(url, { params });
	return data;
};

export const useGetCustomReportReviewFiles = ({ organization_id, company_id, offset, limit, filter }: FileDTO) => {
	const enabled = !!organization_id && !!company_id;
	const files = useQuery(
		['custom_report_review_files', { organization_id, company_id, offset, limit, ...filter }],
		() => getCustomReportReviewFiles({ organization_id, company_id, filter, offset, limit }),
		{ enabled }
	);

	return files;
};
